"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBuildTestSelector = void 0;
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
var useBuildTestSelector = function (name) {
    var debug = (0, SharkMorphContext_1.useSharkMorphContext)().debug;
    return debug ? { 'data-test': name } : undefined;
};
exports.useBuildTestSelector = useBuildTestSelector;
//# sourceMappingURL=buildTestSelector.js.map